// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","copyright":"Footer_copyright__2wqDr","links":"Footer_links__3Cx6x","bold":"Footer_bold__2X3Dx"};